module.exports = "https://www.gc-pro.gnp.com.mx/3e0f2b7f6974f52f546a16b055bcbebe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-15.jpg
// module id = 942
// module chunks = 0 1